/* the header must be anchored to the viewport, not to a section wrapper that the
   theme leaves a transform on - so put it straight on <body> before anything else */
(function(){
  var n=document.getElementById("nav");
  if(n && n.parentElement !== document.body) document.body.insertBefore(n, document.body.firstChild);
})();
/* keep --navh in sync with the real nav height so the mobile film sits flush under it */
(function(){
  var nav=document.querySelector(".nav");
  function setNav(){
    if(nav) document.documentElement.style.setProperty("--navh",Math.round(nav.getBoundingClientRect().height)+"px");
  }
  setNav();
  window.addEventListener("resize",setNav,{passive:true});
  window.addEventListener("load",setNav);
})();
(function(){
  var nav = document.getElementById("nav");
  var journey = document.getElementById("journey");
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* reviews: side arrows */
  var rail = document.getElementById("rail");
  if (rail){
    var step = function(){ return Math.min(rail.clientWidth * 0.75, 700); };
    document.getElementById("revPrev").addEventListener("click", function(){ rail.scrollBy({left:-step(),behavior:"smooth"}); });
    document.getElementById("revNext").addEventListener("click", function(){ rail.scrollBy({left: step(),behavior:"smooth"}); });
  }

  /* breathing: reveal each element as it arrives */
  var rises = Array.prototype.slice.call(document.querySelectorAll(".rise"));
  if (reduced || !("IntersectionObserver" in window)){
    rises.forEach(function(el){ el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { rootMargin:"0px 0px -12% 0px", threshold:0.08 });
    rises.forEach(function(el, i){
      el.style.transitionDelay = (Math.min(i,6) * 60) + "ms";
      io.observe(el);
    });
  }

  if (reduced){ nav.classList.add("solid"); return; }

  var video  = journey.querySelector("video");
  var poster = journey.querySelector(".poster");
  var copies = Array.prototype.slice.call(journey.querySelectorAll(".copy"));
  var dots   = Array.prototype.slice.call(journey.querySelectorAll(".dots i"));
  if (!video) return;

  var isMobile = window.matchMedia("(max-width: 860px)").matches;
  var ready=false, painted=false, primed=false, applied=-1, active=-1, BANDS=copies.length;
  function clamp(n,a,b){ return Math.max(a,Math.min(b,n)); }

  video.src = (isMobile && video.dataset.srcM) ? video.dataset.srcM : video.dataset.src;
  video.addEventListener("loadedmetadata", function(){ ready = true; frame(); });
  video.addEventListener("seeked", function(){ if(!painted){ painted=true; poster.classList.add("gone"); } });
  video.load();

  function prime(){
    if (primed) return; primed = true;
    var p = video.play();
    if (p && p.then) p.then(function(){ video.pause(); }).catch(function(){});
    else { try { video.pause(); } catch(e){} }
  }
  ["touchstart","pointerdown","click","keydown"].forEach(function(ev){
    window.addEventListener(ev, prime, { once:true, passive:true });
  });

  function frame(){
    var vh = window.innerHeight;
    var rect = journey.getBoundingClientRect();
    var span = Math.max(1, journey.offsetHeight - vh);
    var p = clamp(-rect.top / span, 0, 1);

    nav.classList.toggle("solid", rect.bottom < vh * 0.5);

    var size = 1 / BANDS;
    var current = clamp(Math.floor(p / size), 0, BANDS - 1);
    for (var i = 0; i < BANDS; i++){
      var s0 = i*size, s1 = s0+size, fade = size*0.26;
      var inP  = (i === 0) ? 1 : clamp((p - s0)/fade, 0, 1);
      var outP = (i === BANDS-1) ? 0 : clamp((p - (s1-fade))/fade, 0, 1);
      var op = inP * (1 - outP);
      copies[i].style.opacity = op.toFixed(3);
      copies[i].style.transform = "translate3d(0," + ((1-inP)*20 - outP*20).toFixed(1) + "px,0)";
      copies[i].style.pointerEvents = op > 0.5 ? "auto" : "none";
    }
    if (current !== active){
      active = current;
      dots.forEach(function(d,i){ d.classList.toggle("on", i === active); });
    }
    if (ready && video.duration){
      var t = p * (video.duration - 0.06);
      if (Math.abs(t - applied) >= 0.016 && !video.seeking){
        applied = t;
        try { video.fastSeek ? video.fastSeek(t) : (video.currentTime = t); } catch(e){}
      }
    }
  }

  var queued = false;
  function onScroll(){
    if (queued) return; queued = true;
    requestAnimationFrame(function(){ frame(); queued = false; });
  }
  window.addEventListener("scroll", onScroll, { passive:true });
  window.addEventListener("resize", function(){
    var m = window.matchMedia("(max-width: 860px)").matches;
    if (m !== isMobile){
      isMobile = m;
      var src = (isMobile && video.dataset.srcM) ? video.dataset.srcM : video.dataset.src;
      if (video.src.indexOf(src) === -1){ ready=false; applied=-1; video.src=src; video.load(); }
    }
    onScroll();
  });
  frame();
})();

/* scenic bands drift a little as they pass, so they read as part of the scroll */
(function(){
  var scenes=[].slice.call(document.querySelectorAll(".scene"));
  if(!scenes.length) return;
  if(window.matchMedia("(prefers-reduced-motion:reduce)").matches) return;
  var queued=false;
  function paint(){
    queued=false;
    var vh=window.innerHeight;
    for(var i=0;i<scenes.length;i++){
      var sc=scenes[i], r=sc.getBoundingClientRect();
      if(r.bottom<-120||r.top>vh+120) continue;
      var p=(r.top+r.height/2-vh/2)/(vh/2);
      if(p>1)p=1; if(p<-1)p=-1;
      sc.style.setProperty("--py",(p*(sc.classList.contains("solo")?26:20)).toFixed(1)+"px");
    }
  }
  function tick(){ if(!queued){ queued=true; requestAnimationFrame(paint); } }
  window.addEventListener("scroll",tick,{passive:true});
  window.addEventListener("resize",tick,{passive:true});
  window.addEventListener("load",paint);
  paint();
})();

/* ---- photo fan: a curved wall of shots that drifts as you scroll (and drags) ---- */
(function(){
  var fan = document.getElementById("fan");
  var rail = document.getElementById("fanRail");
  if (!fan || !rail) return;
  if (window.matchMedia("(prefers-reduced-motion:reduce)").matches) return;

  var cards = Array.prototype.slice.call(rail.querySelectorAll(".fcard"));
  var N = cards.length;
  if (!N) return;

  var cw, ch, step, visible, rot, dip, depth, drag = 0, centre = 0, queued = false;

  function measure(){
    var w = window.innerWidth;
    if (w <= 560){ cw = Math.round(w * 0.30); visible = 4; }
    else if (w <= 860){ cw = Math.round(w * 0.235); visible = 5; }
    else if (w <= 1280){ cw = Math.round(w * 0.155); visible = 6; }
    else { cw = Math.min(230, Math.round(w * 0.135)); visible = 7; }
    cw = Math.max(96, cw);
    ch = Math.round(cw * 1.5);
    step = Math.round(cw * 0.93);
    rot = (w <= 860) ? 9 : 7.4;
    dip = Math.round(ch * 0.055);
    depth = Math.round(cw * 0.13);
    fan.style.setProperty("--fan-h", (ch + dip * 3 + 26) + "px");
    fan.style.setProperty("--fc-w", cw + "px");
    fan.style.setProperty("--fc-h", ch + "px");
  }

  function paint(){
    queued = false;
    var r = fan.getBoundingClientRect();
    var vh = window.innerHeight;
    /* 0 → 1 across the whole time the fan is on screen */
    var span = vh + r.height;
    var p = (vh - r.top) / span;
    p = Math.max(0, Math.min(1, p));
    /* the wall loops, so it is always full edge to edge */
    centre = p * (N * 0.55) + drag;

    var half = N / 2;
    for (var i = 0; i < N; i++){
      var d = ((((i - centre) % N) + N + half) % N) - half;
      var ad = Math.abs(d);
      if (ad > visible + 1.4){ cards[i].style.display = "none"; continue; }
      cards[i].style.display = "";
      var x = d * step;
      var y = -Math.pow(ad, 1.3) * dip * 0.34;
      var z = -Math.pow(ad, 1.2) * depth;
      var ry = Math.max(-34, Math.min(34, -d * rot));
      var fade = Math.max(0, Math.min(1, (visible + 1.4 - ad) / 1.6));
      cards[i].style.transform =
        "translate3d(" + x.toFixed(1) + "px," + (y - ch / 2).toFixed(1) + "px," + z.toFixed(1) + "px)" +
        " translateX(-50%) rotateY(" + ry.toFixed(2) + "deg)";
      cards[i].style.opacity = fade.toFixed(3);
      cards[i].style.zIndex = String(200 - Math.round(ad * 10));
      cards[i].style.filter = "brightness(" + (1 - Math.min(0.26, ad * 0.038)).toFixed(3) + ")";
    }
  }

  function tick(){ if (!queued){ queued = true; requestAnimationFrame(paint); } }

  /* drag to push the wall along */
  var down = false, startX = 0, startDrag = 0, moved = 0;
  fan.addEventListener("pointerdown", function(e){
    down = true; moved = 0; startX = e.clientX; startDrag = drag;
    fan.classList.add("grabbing");
    try { fan.setPointerCapture(e.pointerId); } catch(err){}
  });
  fan.addEventListener("pointermove", function(e){
    if (!down) return;
    var dx = e.clientX - startX;
    moved = Math.abs(dx);
    if (moved > 6) e.preventDefault();
    drag = startDrag - dx / step;
    tick();
  });
  function release(e){
    if (!down) return;
    down = false; fan.classList.remove("grabbing");
    try { fan.releasePointerCapture(e.pointerId); } catch(err){}
  }
  fan.addEventListener("pointerup", release);
  fan.addEventListener("pointercancel", release);

  window.addEventListener("scroll", tick, { passive:true });
  window.addEventListener("resize", function(){ measure(); tick(); }, { passive:true });
  window.addEventListener("load", function(){ measure(); paint(); });
  measure(); paint();
})();
